<template>
  <div>
    <!--container-->
    <v-container>
      <!--tob bar-->
      <bar />
      <!--tob bar end-->

      <!--template-->
      <template>
        <!--alert box-->
        <v-alert
          text
          dense
          color="teal"
          icon="mdi-clock-fast"
          border="left"
          v-if="brandStatusmsg"
        >
          <div v-for="(resp, i) in brandResponse" :key="i">
            {{ resp }}
          </div>
        </v-alert>
        <!--alert box end-->

        <!---datatable -->
        <v-data-table
          :headers="headers"
          :items="brands"
          :search="search"
          sort-by="name"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>LOB</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-btn color="black" dark class="mb-2" to="/brand/add">
                NEW LOB
              </v-btn>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="editBrand(item)">
              mdi-pencil
            </v-icon>
          </template>
        </v-data-table>
        <!---datatable end-->
      </template>
      <!--template end-->
    </v-container>
    <!--container end-->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import router from "../../router";
export default {
  name: "Brand",
  data: () => ({
    search: "",
    headers: [
      { text: "Actions", value: "actions", sortable: false },
      {
        text: "LOB",
        align: "start",
        sortable: true,
        value: "name"
      },
      
    ]
  }),

  computed: {
    ...mapGetters(["brandList", "brandStatus", "brandStatusResponse"]),
    brands: function() {
      return this.brandList;
    },
    brandStatusmsg: function() {
      return this.brandStatus === "success";
    },
    brandResponse: function() {
      return this.brandStatusResponse;
    }
  },

  watch: {},

  created() {
    this.fetchBrand();
  },

  methods: {
    ...mapActions(["fetchBrand"]),

    editBrand(item) {
      const id = item.id;
      //  router.push({ name: 'ProductGroupEdit', params: { productgroupId: 123 }})
      router.push({ path: `/brand/edit/${id}` });
    }
  }
};
</script>
